import React from "react"
import ReactDOM from "react-dom"
import classnames from "classnames"

import { H4 } from "@infotech/uikit-text"
import { CloseIcon } from "@infotech/uikit-icons"
import { ContentCell, Flex, Div } from "@infotech/uikit-grid"

import withModalSetup from "./withModalSetup"

import styles from "./styles.css"

class Modal extends React.Component {
  componentDidMount() {
    const { fullWidth } = this.props

    if (fullWidth) {
      window.addEventListener(`resize`, this.rerender, false)
    }
  }

  componentWillUnmount() {
    const { fullWidth } = this.props

    if (fullWidth) {
      window.removeEventListener(`resize`, this.rerender, false)
    }
  }

  rerender = () => this.forceUpdate()

  render() {
    const {
      isModalMounted,
      title,
      children,
      isOpen,
      onCancel,
      fullWidth,

      fullHeight = true,
      width,
      containerDomNode,
      isMenuVisible,
      areMenuCaptionsVisible,
      noFooter,
      SIDEBAR_WIDTH,
      SIDEBAR_COMPACT_WIDTH,
      hasOverlay,
    } = this.props
    if (!isOpen) {
      return null
    }

    const style = {}
    if (width && !fullWidth) {
      style.width = `${width}px`
    } else if (fullWidth) {
      const getSubtrahend = () => {
        if (isMenuVisible && areMenuCaptionsVisible) {
          return SIDEBAR_WIDTH + 1
        }
        if (isMenuVisible) {
          return SIDEBAR_COMPACT_WIDTH + 1
        }
        return 0
      }

      style.width = `${document.body.clientWidth - getSubtrahend()}px`
    }

    const footer = !noFooter && (
      <Flex className={styles[`modal-footer-wrapper`]} bt bb />
    )

    return ReactDOM.createPortal(
      <>
        <div
          className={classnames(styles[`modal-wrapper`], {
            [styles[`full-width`]]: fullWidth,
          })}
          style={style}
        >
          <Flex bb className={styles[`modal-title-wrapper`]}>
            <ContentCell flex className={styles[`modal-title-wrapper-2`]}>
              <H4 className={styles[`modal-title`]}>{title}</H4>
            </ContentCell>
            <ContentCell className={styles[`modal-header-buttons`]}>
              {onCancel && (
                <div onClick={onCancel} data-testid="close-entity-modal-icon">
                  <CloseIcon size="medium" className={styles[`close-icon`]} />
                </div>
              )}
            </ContentCell>
          </Flex>
          <Flex
            column
            id="IdForResourceTypeDnDScroll"
            className={styles[`modal-main-wrapper`]}
          >
            <Flex
              column
              className={classnames({
                [styles[`full-height`]]: fullHeight && !noFooter,
                [styles[`full-height-no-footer`]]: fullHeight && noFooter,
              })}
            >
              {isModalMounted ? children : null}
            </Flex>
          </Flex>
          {footer}
          {fullHeight || (
            <Flex className={styles[`modal-bottom-space-eater`]} />
          )}
        </div>
        {hasOverlay && <Div className={styles.Overlay} />}
      </>,
      containerDomNode,
    )
  }
}

export default withModalSetup(Modal)
